import type { HttpQueryParam } from "@/core/interfaces";

/**
 * Mapa coluna da tela → chave do core (`null`: coluna que não vai ao arquivo, como Foto, Ações ou a lupa). Tipado pela
 * união das colunas da tela: esquecer uma coluna falha no `type-check`.
 */
export type ExportColumnKeys<C extends string> = Readonly<Record<C, string | null>>;

/**
 * Anexa `colunas` (chaves do core, na ordem da tela) à exportação. O throw é só a rede para coluna fora do mapa (dado
 * que o tipo não pegou); sem nenhuma coluna a chave não vai e o core exporta todas.
 */
export function appendExportColumns<C extends string>(
  params: Record<string, HttpQueryParam>,
  visibleColumns: readonly C[] | undefined,
  keys: ExportColumnKeys<C>,
  screen: string,
): void {
  const colunas = (visibleColumns ?? []).flatMap((column) => {
    if (!(column in keys)) {
      throw new Error(`Exportação de ${screen}: a coluna "${column}" não tem chave no contrato.`);
    }
    return keys[column] ?? [];
  });
  if (colunas.length > 0) params.colunas = colunas;
}
